import { BasicTransport, Transport, TransportContainer } from '../types';

export type Transports = Partial<Record<TransportType, BasicTransport>>;
export type TransportType = 'rudder' | 'gtm' | 'debug';

const isAwaitable = (transport: BasicTransport): transport is Transport => 'awaitInitialized' in transport;

export const createTransportContainer = (transportsMap: Transports): TransportContainer => {
  const transports = Object.values(transportsMap);
  return {
    identify: async (...args) => {
      await Promise.all(transports.map(transport => transport.identify(...args)));
    },
    page: async (...args) => {
      await Promise.all(transports.map(transport => transport.page(...args)));
    },
    track: async (...args) => {
      await Promise.all(transports.map(transport => transport.track(...args)));
    },
    awaitInitialized: async () => {
      await Promise.all(transports.filter(isAwaitable).map(transport => transport.awaitInitialized()));
    },
    startSendingEvents: async (transport?: TransportType) => {
      if (transport) {
        return transportsMap[transport]?.startSendingEvents?.();
      } else {
        await Promise.all(transports.map(transport => transport.startSendingEvents?.()));
      }
    },
    stopSendingEvents: (transport?: TransportType) => {
      if (transport) {
        transportsMap[transport]?.stopSendingEvents?.();
      } else {
        transports.forEach(transport => transport.stopSendingEvents?.());
      }
    },
  };
};
